// src/firebase.js

import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { initializeFirestore, persistentLocalCache, persistentMultipleTabManager } from "firebase/firestore";
import { getFunctions } from "firebase/functions";
import { getMessaging, isSupported } from "firebase/messaging";

// Firebase yapılandırma bilgileriniz — .env dosyasından okunur
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || "AIzaSyBsXp-5iAVSQ7_FAuPI4sVmdD7InVbTAiI",
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || "fir-onmuhasebereact.firebaseapp.com",
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || "fir-onmuhasebereact",
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || "fir-onmuhasebereact.firebasestorage.app",
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || "507132992853",
  appId: process.env.REACT_APP_FIREBASE_APP_ID || "1:507132992853:web:3a1df04e237adabd14a3dc",
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || "G-Q53HFF6743"
};

// Firebase'i başlat
const app = initializeApp(firebaseConfig);

// Diğer modüllerde kullanmak için servisleri export et
export const auth = getAuth(app);

// Firestore — Modern persistence API ile çoklu tab desteği
// İnternet bağlantısı kesildiğinde uygulama çalışmaya devam eder
// Bağlantı tekrar geldiğinde otomatik senkronize olur
// persistentMultipleTabManager: Birden fazla tab'da eşzamanlı offline destek
export const db = initializeFirestore(app, {
  localCache: persistentLocalCache({
    tabManager: persistentMultipleTabManager()
  })
});

export const functions = getFunctions(app);

export const messaging = async () => {
  try {
    const supported = await isSupported();
    if (supported) {
      return getMessaging(app);
    }
  } catch (err) {
    console.warn("Firebase Messaging is not supported on this browser:", err);
  }
  return null;
};